import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Button } from 'react-bootstrap';
import PageContainer from '../../../components/PageContainer';
import UtilService from '../../../services/util';
import RelatorioApiService from '../../../services/api/RelatorioApiService';
import { useHistory } from 'react-router-dom';
import { MdOutlineArrowBack } from 'react-icons/md';
import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Loading from '../../../components/Loading';
import { FiInfo } from 'react-icons/fi';

function RelatorioComparativoView() {
    // uses
    const params = useParams();
    const history = useHistory();

    // States
    const [visiblePopup, setVisiblePopup] = useState(null);
    const [loading, setLoading] = useState(false);
    const [comparativoCusto, setComparativoCusto] = useState([]);
    const [ano, setAno] = useState("");
    const anosSelecionados = comparativoCusto?.ano?.map(item => item?.ano);

    // style pop-up
    const popupStyle = {
        position: 'absolute',
        top: '-250%',
        left: '-70%',
        transform: 'translateX(-55%)',
        backgroundColor: '#e9e9e9',
        color: '#212529',
        border: '1px solid #dee2e6',
        borderRadius: '5px',
        padding: '5px 10px',
        zIndex: 1000,
        whiteSpace: 'nowrap',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        width: 'auto',
        fontWeight: 'normal'
    };

    // Chamada da api que tras todos os dados do relatorio no mesmo json
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            let res;
            if (params.dataInicial == "all" && params.dataFinal == "all") {
                res = await RelatorioApiService.getComparativoCustoTodos(params.key, params.id);
            } else {
                res = await RelatorioApiService.getComparativoCustoPeriodo(params.key, params.id, params.dataInicial, params.dataFinal);
            }

            setComparativoCusto(res.data);

            if (res.data?.ano?.length > 0) {
                setAno(res.data.ano[0].ano);
            }

            setLoading(false);
        }
        fetchData();
    }, []);

    // Funcao para exportar os dados do relatorio para uma tabela excel
    const exportDataInExcel = async (data) => {
        const header = [
            ['Mês', 'Ano', 'Custo Previsto na Venda', 'Custo Real', 'Variação'],
        ];
    
        const formattedData = data.flatMap((anoData) => {
            return anoData.mes.map((mesData) => {
                const formatCost = (cost) => {
                    if (cost === "-" || cost === undefined) return "";
                    return parseFloat(
                        cost
                            .toString()
                            .replace('R$ ', '')
                            .replace(/\./g, '')
                            .replace(',', '.')
                    ) || "";
                };
    
                return {
                    mes: mesData.mesLabel || '-',
                    ano: mesData.ano || '-',
                    predictedCost: formatCost(mesData.custoPrevisto) || 0,
                    realCost: formatCost(mesData.custoReal) || 0,
                    variation: mesData.variacao || '-',
                };
            });
        });
    
        UtilService.exportXls(formattedData, `Relatório Comparativo de Custo: ${params.key} - ${anosSelecionados}`, header);
    };

    // Grafico customizado
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div
                    tabIndex="-1"
                    className="recharts-tooltip-wrapper recharts-tooltip-wrapper-right recharts-tooltip-wrapper-bottom"
                >
                    <div
                        className="recharts-default-tooltip"
                        style={{
                            margin: '0px',
                            padding: '10px',
                            backgroundColor: 'rgb(255, 255, 255)',
                            border: '1px solid rgb(204, 204, 204)',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        <p className="recharts-tooltip-label" style={{ margin: '0px' }}>
                            {label}
                        </p>
                        <ul className="recharts-tooltip-item-list" style={{ padding: '0px', margin: '0px' }}>
                            <li className="recharts-tooltip-item" style={{ display: 'block', paddingTop: '4px', paddingBottom: '4px', color: '#00c49f' }}>
                                <span className="recharts-tooltip-item-name">Custo Previsto na Venda</span>
                                <span className="recharts-tooltip-item-separator"> : </span>
                                <span className="recharts-tooltip-item-value">R$ {!isNaN(payload[0].value) ? payload[0].value.toLocaleString('pt-br') : "-"}</span>
                                <span className="recharts-tooltip-item-unit"></span>
                            </li>
                            <li className="recharts-tooltip-item" style={{ display: 'block', paddingTop: '4px', paddingBottom: '4px', color: '#0088fe' }}>
                                <span className="recharts-tooltip-item-name">Custo Real</span>
                                <span className="recharts-tooltip-item-separator"> : </span>
                                <span className="recharts-tooltip-item-value">R$ {!isNaN(payload[1].value) ? payload[1].value.toLocaleString('pt-br') : "-"}</span>
                                <span className="recharts-tooltip-item-unit"></span>
                            </li>
                            <li className="recharts-tooltip-item" style={{ display: 'block', paddingTop: '4px', paddingBottom: '4px', color: 'rgb(255, 115, 0)' }}>
                                <span className="recharts-tooltip-item-name">Variação</span>
                                <span className="recharts-tooltip-item-separator"> : </span>
                                <span className="recharts-tooltip-item-value">
                                    {!isNaN(payload[2]?.value) ? `${payload[2].value.toFixed(2)}%` : "-"}
                                </span>
                                <span className="recharts-tooltip-item-unit"></span>
                            </li>

                        </ul>
                    </div>
                </div>
            );
        }

        return null;
    };

    // Funcao para selecionar o ano do grafico
    const selectedAno = comparativoCusto?.ano?.find((item) => item.ano === ano);

    // Modal do grafico
    const dataGrafic = selectedAno?.mes?.map((mes) => ({
        month: mes.mesLabel,
        predictedCost: mes.custoPrevisto === "-" ? 0 : parseFloat(mes.custoPrevisto.replace('.', '').replace(',', '.')),
        realCost: mes.custoReal === "-" ? 0 : parseFloat(mes.custoReal.replace('.', '').replace(',', '.')),
        variation: mes.variacao === "-" ? 0 : parseFloat(mes.variacao.replace(',', '.').replace('%', ''))
    })) || [];

    const actions = [
        {
            label: 'Voltar',
            icon: <MdOutlineArrowBack />,
            color: 'info',
            type: 'button',
            onClick: () => history.goBack()
        }
    ];

    return (
        loading ? <Loading message="Carregando dados..." /> :
            comparativoCusto.totalCustoPrevisto == 0 && comparativoCusto.totalCustoReal == 0 ?
                <PageContainer title={`Comparativo de Custo ${params.key}`} actions={actions}>
                    <h5>Não existe dados para o período selecionado.</h5>
                </PageContainer> :
                <PageContainer title={`Comparativo de Custo ${params.key} - ${anosSelecionados}`} actions={actions}>
                    <Button onClick={() => exportDataInExcel(comparativoCusto.ano)} className='mb-3'>Exportar</Button>
                    <div className='w-25'>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>
                                        Total Variação Acumulada
                                        <span
                                            onMouseEnter={() => setVisiblePopup('variation_total')}
                                            onMouseLeave={() => setVisiblePopup(null)}
                                            className="ml-1 info-icon"
                                            style={{ position: 'relative', cursor: 'pointer' }}
                                        >
                                            <FiInfo />
                                            {visiblePopup === 'variation_total' && (
                                                <div className="hover-popup" style={popupStyle}>
                                                    Diferença entre o Custo Previsto na Venda e o Custo Real acumulado até o último mês fechado.
                                                </div>
                                            )}
                                        </span>
                                    </th>
                                    <th style={{ color: comparativoCusto?.totalVariacaoAcumuladaFechada < 0 ? "red" : "green" }}>{comparativoCusto?.totalVariacaoAcumuladaFechada?.toLocaleString('pt-br', { style: 'percent', minimumFractionDigits: 2 })}</th>
                                </tr>
                            </thead>
                        </Table>
                    </div>

                    <Table bordered style={{ background: "rgb(225, 234, 243)" }}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Total Custo Previsto na Venda</th>
                                <th>Total Custo Real</th>
                                <th>
                                    Total Variação
                                    <span
                                        onMouseEnter={() => setVisiblePopup('variation')}
                                        onMouseLeave={() => setVisiblePopup(null)}
                                        className="ml-1 info-icon"
                                        style={{ position: 'relative', cursor: 'pointer' }}
                                    >
                                        <FiInfo />
                                        {visiblePopup === 'variation' && (
                                            <div className="hover-popup" style={popupStyle}>
                                                Diferença entre o Custo Previsto na Venda e o Custo Real: (CP - CR) / CP
                                            </div>
                                        )}
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><b>Total:</b></td>
                                <td><b>{comparativoCusto?.totalCustoPrevisto?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</b></td>
                                <td><b>{comparativoCusto?.totalCustoReal?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</b></td>
                                <td style={{ color: comparativoCusto?.totalVariacao < 0 ? "red" : "green" }}><b>{comparativoCusto?.totalVariacao?.toLocaleString('pt-br', { style: 'percent', minimumFractionDigits: 2 })}</b></td>
                            </tr>
                        </tbody>
                    </Table>

                    {comparativoCusto?.ano?.map((item, index) => (
                        <React.Fragment key={index}>
                            <h5><b>Ano:</b> {item.ano}</h5>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Mês</th>
                                        <th>Custo Previsto na Venda</th>
                                        <th>Custo Real</th>
                                        <th>Variação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {item.mes.map((mes, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{mes.mesLabel}</td>
                                            <td>R$ {mes.custoPrevisto.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                            <td>R$ {mes.custoReal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                            <td style={{ color: parseFloat(mes.variacao.replace(',', '.')) < 0 ? "red" : "green", fontWeight: "bold" }}>
                                                {mes.variacao.toLocaleString('pt-br', { style: 'percent', minimumFractionDigits: 2 })}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td><b>Total:</b></td>
                                        <td></td>
                                        <td><b>{item.totalCustoPrevisto.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</b></td>
                                        <td><b>{item.totalCustoReal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</b></td>
                                        <td style={{ color: item.totalVariacao < 0 ? "red" : "green" }}><b>{item.totalVariacao.toLocaleString('pt-br', { style: 'percent', minimumFractionDigits: 2 })}</b></td>
                                    </tr>
                                </tfoot>
                            </Table>
                        </React.Fragment>
                    ))}
                    <div className="w-100 d-flex justify-content-center mt-3">
                        <select style={{ padding: "8px 16px", borderRadius: "10px", border: "1px solid #555", color: "#555", background: "transparent" }}
                            value={ano}
                            onChange={(e) => setAno(e.target.value)}
                        >
                            {comparativoCusto?.ano?.map((ano, index) => (
                                <option key={index} value={ano.ano}>{ano.ano}</option>
                            ))}
                        </select>
                    </div>
                    <ResponsiveContainer width="100%" height={400}>
                        <ComposedChart data={dataGrafic} margin={{ top: 20, right: 30, left: 20, bottom: 5 }} >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="month" />
                            <YAxis yAxisId="left" tickFormatter={(value) => `R$ ${value.toLocaleString('pt-br')}`} />
                            <YAxis yAxisId="right" orientation="right" tickFormatter={(value) => `${value.toFixed(2)}%`} />
                            <Tooltip content={<CustomTooltip />} />
                            <Legend />
                            <Bar yAxisId="left" dataKey="predictedCost" fill="#00c49f" name="Custo Previsto na Venda" />
                            <Bar yAxisId="left" dataKey="realCost" fill="#0088fe" name="Custo Real" />
                            <Line yAxisId="right" dataKey="variation" name="Variação (%)" stroke="#ff7300" strokeWidth={2} />
                        </ComposedChart>
                    </ResponsiveContainer>
                </PageContainer>
    )
} export default RelatorioComparativoView